/**
 * 软著 软著列表
 */
<template>
  <div class="ph-container">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
      <!-- <el-breadcrumb-item>公司管理</el-breadcrumb-item> -->
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.business_name" placeholder="请输入企业名称" clearable></el-input>
      </el-form-item>
      <!-- <el-form-item label="">
        <el-input size="small" v-model="formInline.deptNo" placeholder="输入部门代码"></el-input>
      </el-form-item> -->
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <!-- <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button> -->
        <!-- <el-button size="small" type="primary" icon="el-icon-folder-add" title="批量导入企业信息" @click="handleImport()">导入</el-button> -->
        <el-button size="small" type="primary" icon="el-icon-folder-remove" title="导出满足搜索条件的所有数据" @click="exportSearch()">导出</el-button>
        <!-- <el-button size="small" type="danger" icon="el-icon-delete" title="批量删除勾选的企业信息" @click="handleEdit()">删除</el-button> -->
      </el-form-item>
      <span style="float: right;font-size: 14px;line-height: 40px;">搜索结果：<span style="color: #F56C6C;">{{ searchTotal }}条</span></span>
    </el-form>
    <div style="display: flex;font-size: 1rem;">
      <div class="search-sidebar" v-if="isRefresh">
        <div v-if="ifCollapseOperate">
          <div v-for="(item,index) in collapseOperate" :key="index" style="border:1px solid  #a9d5de;margin: 12px;padding: 15px;background-color: #F8FFFF;display: flex;">
            <div>
              <span style="color: #276F86;">{{ item.event }}</span>
              <span>{{ item.type }}</span>
              <span style="color: #276F86;">({{ item.value }})</span>
            </div>
            <i class="el-dialog__close el-icon el-icon-close" style="cursor: pointer;" @click="delCollapseOperate(index)"></i>
          </div>
        </div>
        <el-collapse style="border: 0px;">
          <div @click="collapseApplicant">
            <el-collapse-item title="著作权人" style="margin: 15px 0px 10px 10px;">
              <div v-loading="collapseApplicantLoading" class="leftCheckbox">
                  <el-checkbox-group v-model="collapseApplicantCheckList" class="applicantGroup">
                    <el-checkbox v-for="item in collapseApplicantArr" :label="item.name" :key="item.name">{{ item.name }}(<span style="color: #4169E1;">{{ item.number }}</span>)</el-checkbox>
                  </el-checkbox-group>
                <div style="margin-top: 15px;">
                    <el-button class="filter_btn" @click="patentApplicantFilter()">筛选</el-button>
                    <el-button class="perk_btn" @click="patentApplicantPerk()">过滤</el-button>
                </div>
              </div>
            </el-collapse-item>
          </div>
        </el-collapse>
      </div>
      <!--列表-->
      <div style="margin-left: 15px;width: 90%;">
        <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
          <el-table-column align="center" type="selection" width="60">
          </el-table-column>
          <el-table-column align="center" prop="reg_time" label="登记批准日期">
          </el-table-column>
          <el-table-column align="center" prop="full_name" label="软件全称">
          </el-table-column>
          <el-table-column align="center" prop="simple_name" label="软件简称">
          </el-table-column>
          <el-table-column align="center" prop="author_nationality" label="著作权人">
          </el-table-column>
          <el-table-column align="center" prop="reg_num" label="登记号">
          </el-table-column>
          <el-table-column align="center" prop="version" label="版本号">
          </el-table-column>
          <el-table-column align="center" prop="cat_num" label="分类号">
          </el-table-column>
          <!-- <el-table-column align="center" prop="patent_num" label="行业分类">
          </el-table-column> -->
          <el-table-column align="center" prop="publish_time" label="首次发表日期">
          </el-table-column>
          <!-- <el-table-column align="center" prop="soft_num" label="软著数">
          </el-table-column>
          <el-table-column align="center" prop="add_time" label="添加时间">
          </el-table-column> -->
          <el-table-column align="center" label="操作" min-width="120">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" icon="el-icon-edit-outline" @click="handleEdit(scope.$index, scope.row)">详情</el-button>
              <!-- <el-button size="mini" type="danger" icon="el-icon-delete" @click="deleteBusiness(scope.$index, scope.row)">删除</el-button> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog title="软件著作权详情" :visible.sync="editFormVisible" width="50%" style="text-align: center;font-size: 16px;" @click="closeDialog('editForm')">
      <div class="tyc-modal-body">
        <div>
          <table class="modal-table -striped-col">
            <tr>
              <td width="20%">软件全称</td>
              <td colspan="3">{{ editForm.full_name }}</td>
            </tr>
            <tr>
              <td width="20%">软件简称</td>
              <td width="30%">{{ editForm.simple_name }}</td>
              <td width="20%">登记号</td>
              <td width="30%">{{ editForm.reg_num }}</td>
            </tr>
            <tr>
              <td width="20%">分类号</td>
              <td width="30%">{{ editForm.cat_num }}</td>
              <td width="20%">版本号</td>
              <td width="30%">{{ editForm.version }}</td>
            </tr>
            <tr>
              <td width="20%">著作权人</td>
              <td colspan="3">{{ editForm.author_nationality }}</td>
            </tr>
            <tr>
              <td width="20%">首次发表日期</td>
              <td width="30%">{{ editForm.publish_time }}</td>
              <td width="20%">登记批准日期</td>
              <td width="30%">{{ editForm.reg_time }}</td>
            </tr>
          </table>
        </div>
      </div>
      
    </el-dialog>
  </div>
</template>

<script>
import { editBusiness, 
  delBusiness, 
  webUrl, 
  getSoftNessList,
  getAuthorGroup, 
  getSoftNessFilter,
  exportSearchSoft } from '../../api/patentMG'
import { checkLogin } from '../../utils/util'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      importFormVisible: false, //控制导入页面显示与隐藏
      title: '添加',
      editForm: [],
      searchTotal: 0,
      isRefresh: true,//左侧是否需要刷新
      collapseOperateApi: [],//折叠面板筛选或过滤事件传递值
      collapseOperate: [],// 折叠面板筛选或过滤事件
      ifCollapseOperate: false,// 折叠面板筛选或过滤事件是否存在
      ifCollapseApplicant: true,// 折叠面板商标申请人是否需要查询
      collapseApplicantLoading: true,// 折叠面板商标申请人是否显示加载
      collapseApplicantArr: [],// 折叠面板商标申请人筛选数据
      collapseApplicantCheckList: [],// 折叠面板商标申请人勾选数据
      // rules表单验证
      rules: {
        business_name: [
          { required: true, message: '请输入企业名称', trigger: 'blur' }
        ],
        business_ein: [
          { required: true, message: '请输入企业税号', trigger: 'blur' }
        ],
        username: [
        { required: true, message: '请输入企业负责人', trigger: 'blur' }
        ],
        mobile: [
        { required: true, message: '请输入联系方式', trigger: 'blur' }
        ],
      },
      formInline: {
        page: 1,
        ps: 10,
        business_name: ''
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      setHeader:{
        'token': localStorage.getItem('logintoken')
      },
      uploadExcel:webUrl + '/patent/business/importBusiness',
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {

    // 视频上传oss 开始

    // 文件超出个数限制时的钩子
    handleExceed(files, fileList) {
      this.$message.warning(`每次只能上传 ${this.limit} 个文件`);
    },
    // 点击文件列表中已上传的文件时的钩子
    handlePreview(file) {},
    // 删除文件之前的钩子
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    // 文件列表移除文件时的钩子
    handleRemove(file, fileList) {},
    // 文件上传成功时的钩子
    handleSuccess(response, file, fileList) {
      if(response.code == 200){
          this.$message({
              type: 'success',
              message: response.msg
          })
          this.importFormVisible = false
          this.getdata(this.formInline)
      }else{
          this.$message({
              type: 'error',
              message: response.msg
          })
      }
    },
    //文件上传前的校验
    beforeAvatarVideoUpload(file) {
      const that = this
       if (!/\.(xlsx|xls|XLSX|XLS)$/.test(file.name)) {
          that.$message({
              type: 'error',
              message: '上传文件只能为excel文件，且为xlsx,xls格式!'
          })
          return false
        }

    // 请求后台接口拿配置参数
      return new Promise((resolve, reject) => {
          const configData = {
              region:'oss-cn-qingdao',
              accessKeyId:'LTAI4FuLvbyHn9zoeQgqd5hG',
              accessKeySecret:'23U5LuP39m4TJz8a0snWcOs7Yxq85b',
              bucket:'qzhi2019-oss',
          }
          this.dataObj = configData
          resolve(true)
      });
    },
    // http-request属性来覆盖默认的上传行为（即action="url"），自定义上传的实现 
    Upload(file) {
      console.log(file)
      // 前缀
      // let videoPrefix = 'http://qzhi2019-oss.oss-cn-qingdao.aliyuncs.com/'
      const that = this;
      async function multipartUpload() {
        // let temporary = file.file.name.lastIndexOf(".");
        // let fileName = file.file.name;

        // Excel上传服务器
        that.$axios({
        url: webUrl+'/admin/monitor/importPatMonitor',
        data: file,
        method: 'POST',
        headers: { 
          // "Content-Type": "multipart/form-data",
          "token": localStorage.getItem('logintoken')
          },
      })
        .then(result =>{
          console.log(result)
        })
        .catch(err => {
          console.log("err:", err);
        });
      }
      multipartUpload();
    },
    // 视频上传oss 结束

    // 获取公司列表
    getdata(parameter) {
      this.loading = true
      getSoftNessList(this.formInline)
      .then(res=>{
          if(res.code == 200){
              this.loading = false
              this.listData = res.data.dataList
               // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.page = this.formInline.page
            this.pageparm.pageSize = this.formInline.ps
            this.pageSize = this.formInline.ps
            this.pageparm.total = res.data.total
            this.searchTotal = res.data.total
          }else{
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
      })
    },
        // 商标列表(filter模式)
    getFilter(){
      let parameter = this.formInline
      let collapseOperateApi = this.collapseOperateApi
      parameter.operateApi = JSON.stringify(collapseOperateApi)
      getSoftNessFilter(parameter)
      .then(res=>{
          res = checkLogin(res);
          if(res.code == 200){
              this.loading = false
              this.listData = res.data.dataList
               // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.page = this.formInline.page
            this.pageparm.pageSize = this.formInline.ps
            this.pageSize = this.formInline.ps
            this.pageparm.total = res.data.total
            this.searchTotal = res.data.total
            this.reload()
          }else{
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
      })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.ps = parm.pageSize
      // this.getdata(this.formInline)
      this.getFilter()
    },
    // 搜索事件
    search() {
      // this.getdata(this.formInline)
      this.getFilter()
      this.isRefresh = true
      this.ifCollapseOperate = true
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      console.log(row)
      this.editFormVisible = true
      this.editForm = row
    },

     //显示导入界面
    handleImport: function(index, row) {
      this.title = '企业信息导入'
      this.importFormVisible = true
    },

    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          editBusiness(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.code == 200) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('系统错误,请稍后再试!')
            })
        } else {
          return false
        }
      })
    },
    // 删除公司
    deleteBusiness(index, row) {
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          delBusiness({id:row.id})
            .then(res => {
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: res.msg
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('系统错误,请稍后再试!')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 下载企业信息导入模板
    downloadImport() {
      console.log(999)
    },
        // 删除筛选或过滤项
    delCollapseOperate(index){
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      collapseOperate.splice(index,1)
      collapseOperateApi.splice(index,1)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      if(this.collapseOperate.length <= 0){
        this.ifCollapseOperate = false
      }
      console.log(this.collapseOperate)
      // 执行删除后的操作
      // 查询筛选条件
      this.getFilter()
    },
     // 点击获取折叠面板商标申请人数据
    collapseApplicant(){
      // 判断是否需要重新查询
      let isSearch = this.ifCollapseApplicant
      let that = this
      let parameter = that.formInline
      parameter.operateApi = JSON.stringify(that.collapseOperateApi)
      if(isSearch){
        getAuthorGroup(parameter)
        .then(res=>{
          res = checkLogin(res)
          if(res.code == 200){
             that.collapseApplicantArr = res.data
             that.collapseApplicantLoading = false
             that.ifCollapseApplicant = false
          }
        })
      }
    },
     // 申请人筛选
    patentApplicantFilter(){
      let checkList = this.collapseApplicantCheckList
      let checkListLength = checkList.length
      if(checkListLength <= 0){
        this.$message({
          type: 'warning',
          message: '未勾选筛选项'
        })
        return false
      }
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = []
      let tempApi = []
      if(checkListLength == 1){
        temp = {
          'event': '筛选',
          'type': '著作权人',
          'value': checkList[0]
        }
        tempApi = {
          'event': 1,
          'type': 'author_nationality',
          'value': checkList[0]
        }
      }else{
        let value = ''
        let valueApi = ''
        checkList.forEach(function(item,index){
            if(checkListLength == index+1){
              value += item
              valueApi += item
            }else{
              value += item + ' OR '
              valueApi += item + ';'
            }
        })
        temp = {
          'event': '筛选',
          'type': '著作权人',
          'value': value
        }
        tempApi = {
          'event': 1,
          'type': 'author_nationality',
          'value': valueApi
        }
      }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseApplicantCheckList = []
      // 查询筛选条件
      this.getFilterData()
    },
    // 申请人过滤
    patentApplicantPerk(){
      let checkList = this.collapseApplicantCheckList
      let checkListLength = checkList.length
      if(checkListLength <= 0){
        this.$message({
          type: 'warning',
          message: '未勾选筛选项'
        })
        return false
      }
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = []
      let tempApi = []
      if(checkListLength == 1){
        temp = {
          'event': '过滤',
          'type': '著作权人',
          'value': checkList[0]
        }
        tempApi = {
          'event': 2,
          'type': 'author_nationality',
          'value': checkList[0]
        }
      }else{
        let value = ''
        let valueApi = ''
        checkList.forEach(function(item,index){
            if(checkListLength == index+1){
              value += item
              valueApi += item
            }else{
              value += item + ' OR '
              valueApi += item + ';'
            }
        })
        temp = {
          'event': '过滤',
          'type': '著作权人',
          'value': value
        }
        tempApi = {
          'event': 1,
          'type': 'author_nationality',
          'value': valueApi
        }
      }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseApplicantCheckList = []
      // 查询过滤条件
      this.getFilterData()
    },
    // 左侧筛选或过滤查询
    getFilterData(){
      let parameter = this.formInline
      let collapseOperateApi = this.collapseOperateApi
      parameter.operateApi = JSON.stringify(collapseOperateApi)
      getSoftNessFilter(parameter)
       .then(res => {
        this.loading = false
        if(res.code == 200){
          this.listData = res.data.dataList
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.page = this.formInline.page
            this.pageparm.pageSize = this.formInline.ps
            this.pageSize = this.formInline.ps
            this.pageparm.total = res.data.total
            this.searchTotal = res.data.total
            this.reload()
        }else{
          this.$message({
              type: 'info',
              message: res.msg
            })
        }
      })
      .catch(err => {
          this.loading = false
          this.$message.error('登陆已过期,请重新登陆!')
      })
    },
       //局部刷新
    reload () {
			this.isRefresh = false;
			this.$nextTick(() => {
				this.isRefresh = true
        this.ifCollapseApplicant = true
        this.collapseApplicantLoading = true
        
			})
		},
     // 导出满足搜索条件的所有数据
    exportSearch(){
      let parameter = this.formInline
      let collapseOperateApi = this.collapseOperateApi
      parameter.operateApi = JSON.stringify(collapseOperateApi)
      this.$confirm('确定导出所有满足条件的数据吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
      })
      .then(()=>{
        exportSearchSoft(parameter)
        .then(res=>{
          if(res.code == 200){
            this.$message({
              type: 'success',
              message: '数据导出成功!'
            })
            window.location.href = res.data.url
          }else{
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
        })
      })
      .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消导出'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog(name) {
      if(name == 'editForm'){
        this.editFormVisible = false
      }else if(name == 'importForm'){
        this.importFormVisible = false
      }
      
    }
  }
}
</script>

<style scoped>
.ph-container {
  margin: 0 auto;
  max-width: 1680px;
  min-width: 1024px;
 }
.user-search {
  margin-top: 10px;
}
.userRole {
  width: 100%;
}
.left-filter-top {
  font-size: 14px;
  margin: 10px 0;
  width: 180px;
  border-bottom: 1px solid #EBEEF5;
}
.search-top {
  border: 1px solid #EBEEF5;
  margin: 10px 0;
  border-radius: 5px;
  padding: 0 15px;

}
.el-form-item {
    margin-bottom: 10px;
}
.el-input{
  color: #606266;
  width: auto;

}
.export_scope input{
  width: 60px;
}
.aboutDialog >>> .el-dialog__body{
  padding: 0px !important;
  padding:15px !important;
}
.aboutDialog >>> .el-dialog__header {
  padding: 10px 20px;
  height: 25px;
  line-height: 25px;
  text-align: left;
  background: #F8F8F8;
  border-bottom: solid 1px #eee;
}
.aboutDialog >>> .el-dialog__title {
  color: #333;
  font-size: 14px;
}
.aboutDialog >>> .el-dialog__headerbtn .el-dialog__close {
  color: #333;
}
.search-sidebar {
  width: 10%;
  border: solid 1px #EBEEF5;
  /* margin-left: 15px; */
  min-width: 200px;
  font-size: 14px;
}
.search-sidebar .item {
  display: block;
  font-weight: 400;
  margin: 15px 10px;
}
.filter_btn {
  color: #21BA45;
  border: solid 1px #21BA45;
  padding: 6px 6px;
}
.perk_btn {
  color: #DB2828;
  border: solid 1px #DB2828;
  padding: 6px 6px;
}
.patentInfoBase .el-form-item{
  margin-bottom: 0px;
}
.search-sidebar .el-collapse {
  border-bottom: 0px solid #EBEEF5;;
}
.leftCheckbox >>>.el-checkbox__input {
  position: absolute;
  top: 2px;
  left: 0;
}
.leftCheckbox >>>.el-checkbox__label {
  min-width: 130px;
  max-width: 160px;
  display: inline-block;
  white-space: pre-line;
  word-wrap: break-word;
  overflow: hidden;
  line-height: 19px;
  font-size: 14px;
  padding-left: 20px;
}
.content-item {
  margin-bottom: 2px;
}
.content-label {
  color: #808080;
}
ul {
  list-style: none;
  margin-left: -20px;
  font-size: 12px;
  line-height: 2;
}
.patent-info-column {
  width: 100px;
  display: inline-block;
}
.patent-info-number {
  width: 200px;
  display: inline-block;
}
/* .searchTable > tr {
  height: 40px;
} */
.searchTable .label {
  width: 80px;
  min-width: 80px;
}
.searchTable .select {
  width: 350px;
  min-width: 350px;
}
.searchTable .el-form-item {
  margin-bottom: 5px;
}
.searchTable >>>.el-form-item__label {
  font-weight: 600;
}
.searchTable >>>.el-form-item__content {
  line-height: 20px;
}
.el-dialog-div {
  height: 60vh;
  overflow-x: hidden;
}
.legalContent {
  border: solid 1px #b3b1b1;
  padding: 5px 5px;
  border-radius: 5px;
}
.applicantGroup {
  max-height: 450px;
  overflow-y: scroll;
  overflow-x: hidden;
}
.applicantGroup::-webkit-scrollbar {
    width: 4px;
  }
.applicantGroup::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  opacity: 0.2;
  /* background: fade(#409EFF, 60%); */
}
.applicantGroup::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  /* background: fade(@primary-color, 30%); */
}
.tyc-modal-body {
  max-height: 465px;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 16px;
  min-height: 40px;
}
.modal-table {
    color: #333;
    font-size: 14px;
    max-width: 100%;
    text-align: center;
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
}
.modal-table.-striped-col {
    text-align: left;
}
.modal-table.-striped-col td:nth-child(odd) {
    background-color: #f0f7fc;
}
.modal-table.-striped-col td {
    border: 1px solid #e4eef6;
    font-weight: 400;
    line-height: 1.57143;
    padding: 8px;
    vertical-align: middle;
}
.dialog-i.el-dialog__header {
  text-align: center;
}

</style>

 


// WEBPACK FOOTER //
// src/views/soft/softList.vue